import $ from 'jquery';

class Accordion {
  constructor() {
    this.accordion = $('.js-accordion');

    if (!this.accordion.length) {
      return;
    }

    this.init();
  }

  init() {
    $.each(this.accordion, (i, el) => {
      const accordion = $(el);
      const button = accordion.find('.js-accordion-button');
      const closeOther = accordion.hasClass('has-close-other');

      button.on('click', e => {
        const self = $(e.currentTarget);
        const target = self.data('target');
        const header = self.parent();
        const content = self
          .closest('.js-accordion-item')
          .find(`.js-accordion-content${target}`);

        if (content.length) {
          if (closeOther) {
            const allContents = accordion
              .find('.js-accordion-content.is-open')
              .not(content);
            const allHeaders = accordion
              .find('.js-accordion-header.is-open')
              .not(header);

            allContents.slideUp(400, () => {
              button.not(self).attr('aria-expanded', false);
              allHeaders.removeClass('is-open');
              allContents.removeClass('is-open');
            });
          }

          if (header.hasClass('is-open')) {
            content.slideUp(400, () => {
              self.attr('aria-expanded', false);
              header.removeClass('is-open');
              content.removeClass('is-open');
            });
          } else {
            content.slideDown(400, () => {
              self.attr('aria-expanded', true);
              header.addClass('is-open');
              content.addClass('is-open');
            });
          }
        }
      });
    });
  }
}

export default new Accordion();



// WEBPACK FOOTER //
// ./src/scripts/modules/accordion.js